// AXIOS
import axios from "axios";

// API URL
import { apiUrl_forTestimonials } from "./constants";

// CANCEL TOKEN
const CancelToken = axios.CancelToken;

// get testimonials
export let cancelGetTestimonialsApi;
export async function getTestimonials_API(headers, query) {
    if(headers) {
        const data = await axios.get(
            apiUrl_forTestimonials + `s?${query}`,
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetTestimonialsApi = c;
                }),
            }
        );

        return data;
    } else {
        console.log("Please add required parameters");
    }
}

// add testimonials
export let cancelAddTestimonialsApi;
export async function addTestimonials_API(headers, { status, image, name, review, rating, designation }) {
    if(headers && image && name && review) {
        let formData = new FormData();
        if(designation) {
            formData.append("designation", designation);
        } else {
            formData.append("designation", "");
        }

        formData.append("images[]", image, image.name);        
        formData.append("status", status);
        formData.append("name", name);
        formData.append("review", review);
        formData.append("rating", rating);

        const data = await axios.post(
            apiUrl_forTestimonials,
            formData,
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelAddTestimonialsApi = c;
                }),
            }
        );

        return data;
    } else {
        console.log("Please add required parameters");
    }
}

// edit testimonials
export let cancelEditTestimonialsApi;
export async function editTestimonials_API(headers, { testimonialId, status, image, name, review, rating, designation }) {
    if(headers && testimonialId && image && name && review) {
        let formData = new FormData();        
        if(designation) {
            formData.append("designation", designation);
        } else {
            formData.append("designation", "");
        }        
        if(image?.name) {
            formData.append("images[]", image, image.name);
        }
        formData.append("status", status);
        formData.append("name", name);
        formData.append("review", review);
        formData.append("rating", rating);

        const data = await axios.put(
            apiUrl_forTestimonials + `/${testimonialId}`,
            formData,
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelEditTestimonialsApi = c;
                }),
            }
        );

        return data;
    } else {
        console.log("Please add required parameters");
    }
}

// get testimonials details 
export let cancelGetTestimonialDetailsApi;
export async function getTestimonialDetails_API(headers, testimonialId) {
    if(headers && testimonialId) {
        const data = await axios.get(
            apiUrl_forTestimonials + `/${testimonialId}`,
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetTestimonialDetailsApi = c;
                }),
            }
        );

        return data;
    } else {
        console.log("Please add required parameters");
    }
}

// get testimonials details 
export let cancelDeleteTestimonialApi;
export async function deleteTestimonial_API(headers, testimonialId) {
    if(headers && testimonialId) {
        const data = await axios.get(
            apiUrl_forTestimonials + `/delete/${testimonialId}`,
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelDeleteTestimonialApi = c;
                }),
            }
        );

        return data;
    } else {
        console.log("Please add required parameters");
    }
}